import React from 'react'
import { IReSolvedFeedCard } from './home'
import { ResolveFeedCard } from './resolve-card'

const change_ic = require('static/change_ic@3x_black.png')

interface IQA {
  list: {
    info: IReSolvedFeedCard
    type: number
    unique_id_str: string
  }[]
  onShuffle: () => void
  title: string
}

export default function QA(props: IQA) {
  const { list, onShuffle, title } = props
  return (
    <>
      <div className="videos-wrapper">
        <h2>{title}</h2>
        <div
          className="click-wrapper tw-flex tw-items-center"
          onClick={onShuffle}
        >
          <span className="text">换一换</span>
          <img src={change_ic} alt="换一换" className="icon" />
        </div>
      </div>
      {list.map(item => (
        <div
          key={item.unique_id_str}
          onClick={() => {
            window.open(`/ugc/article/${item.unique_id_str}`, '_blank')
          }}
        >
          <ResolveFeedCard info={item.info} />
        </div>
      ))}
      <style jsx>
        {`
          .videos-wrapper {
            display: flex;
            margin-top: 40px;
            height: 36px;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 16px;
          }

          .click-wrapper {
            display: flex;
            align-items: center;
            cursor: pointer;
          }
          .text {
            margin-left: auto;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #1f2129;
          }
          .icon {
            display: block;
            margin-left: 2px;
            height: 12px;
            width: 12px;
          }
          h2 {
            font-size: 24px;
            font-weight: 500;
            color: #1a1a1a;
          }
        `}
      </style>
    </>
  )
}
